export default {
  ELI_START_SCREEN: 'controllers/scenes/StartScreen',
  ELI_MAIN: 'controllers/scenes/Main',
  ELI_SYMBOL: 'controllers/symbols/ControllerSymbol'
}
